<div
  class="tw-flex tw-gap-2"
  [ngClass]="{ 'tw-opacity-50 tw-cursor-not-allowed': disabled }"
  appKeyboardActivatable
  appKeyboardActivatableRole="checkbox"
  [attr.aria-checked]="checked"
  [appKeyboardActivatableDisabled]="disabled"
  (appKeyboardActivatableActivate)="toggle()"
  (click)="toggle()"
>
  <div
    class="tw-flex-shrink-0 tw-rounded tw-flex tw-items-center tw-justify-center tw-bg-color-surface-input
    {{ !checked ? 'tw-shadow-neuomorphic-inset' : 'tw-bg-' + background }}
    {{ isMobile() && checked ? 'tw-shadow-glow-medium' : '' }}
    {{
      customisedBoxSize()
        ? 'tw-h-' + customisedBoxSize() + ' tw-w-' + customisedBoxSize()
        : 'tw-h-5 tw-w-5'
    }}"
  >
    <ng-container *ngIf="checked">
      <icon
        [size]="4"
        [name]="'check-only'"
        [currentColor]="'light'"
        class="tw-flex tw-items-center tw-justify-center"
      ></icon>
    </ng-container>
  </div>
  <span class="tw-text-[14px] tw-leading-[125%] tw-tracking-[1.25%] tw-text-dt-text-headings">{{
    title | capitalise
  }}</span>
</div>
